import {
  DEFAULT_STATUS,
  getStatusLabel,
  normalizeRunStatus,
} from "@/runs/status"

import type { RunRowLike } from "@/types/RunRow"

export const RUN_RESULTS_GROUP_OPTIONS = [
  {
    id: "status",
    label: "Status",
    value: (row: RunRowLike) =>
      normalizeRunStatus(row.error_status ?? DEFAULT_STATUS),
    format: getStatusLabel,
  },
]
